import { render } from "./StartingFlow.vue?vue&type=template&id=505c0a4e&scoped=true&ts=true"
import script from "./StartingFlow.vue?vue&type=script&lang=ts"
export * from "./StartingFlow.vue?vue&type=script&lang=ts"

import "./StartingFlow.vue?vue&type=style&index=0&id=505c0a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505c0a4e"]])

export default __exports__